define( [ 'jquery' ], function( $ ) {
	'use strict';

	/* eslint-disable */
	$.easing.easeInOutCubic = function( x, t, b, c, d ) {
		var ta = t;
		if ( ( ta /= d / 2 ) < 1 ) {
			return c / 2 * ta * ta * ta + b;
		}
		ta -= 2;
		return c / 2 * ( ta * ta * ta + 2 ) + b;
	};

	$.easing.easeOutQuart = function( x, t, b, c, d ) {
		var ta = t / d - 1;
		return -c * ( ta * ta * ta * ta - 1 ) + b;
	};
	/* eslint-enable */

	return {
		smallTag : 'small',
		mediumTag : 'medium',
		largeTag : 'large',
		urlRegExp : new RegExp( '#[a-zA-Z0-9/?%-]+' ),

		getBreakpoint : function( $element ) {
			var tag;

			if ( window.getComputedStyle ) {
				if ( typeof $element !== 'undefined' && $element.length !== 0 ) {
					tag = window.getComputedStyle( $element[ 0 ], ':after' ).getPropertyValue( 'content' );
				} else {
					tag = window.getComputedStyle( document.body, ':after' ).getPropertyValue( 'content' );
				}
			} else if ( document.documentElement.currentStyle ) {
				if ( typeof $element !== 'undefined' && $element.length !== 0 ) {
					tag = $element[ 0 ].documentElement.currentStyle.fontFamily;
				} else {
					tag = document.documentElement.currentStyle.fontFamily;
				}
			} else {
				tag = this.largeTag;
			}

			tag = tag.replace( /"/g, '' ).replace( /['",]/g, '' );	// Firefox and Android bugfixs

			return tag;
		},

		// Utility function to create a random ID
		makeId : function( prefix ) {
			var newID = '',
				poss = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
				poss_length = poss.length;

			for ( var i = 0; i < 5; i++ ) {
				newID += poss.charAt( Math.floor( Math.random() * poss_length ) );
			}

			return ( prefix ? prefix : '' ) + newID;
		},

		processInPageLinks : function( selector, link_function ) {
			$( 'a[href*="#"]' + selector ).each( function() {
				// The below string fixes are in here because IE6 returns this.pathname and this.host differently
				var pathname = this.pathname;

				if ( pathname.indexOf( '/' ) ) {
					pathname = '/' + pathname;
				}

				var host = this.host
						.replace( ':8080', '' )
						.replace( ':80', '' )
						.replace( ':443', '' ),
					location_host = location.host
						.replace( ':8080', '' )
						.replace( ':80', '' )
						.replace( ':443', '' );

				if ( location.pathname === pathname && location_host === host ) {
					link_function( this );
				}
			});
		},

		debounce : function( func, wait, immediate ) {
			var timeout;
			return function() {
				var context = this,
					args = arguments;
				var later = function() {
					timeout = null;
					if ( !immediate ) {
						func.apply( context, args );
					}
				};
				var call_now = immediate && !timeout;
				clearTimeout( timeout );
				timeout = setTimeout( later, wait );
				if ( call_now ) {
					func.apply( context, args );
				}
			};
		},

		getSettings : function( variable_string ) {
			var settings_var = {};

			if ( typeof variable_string !== 'undefined' ) {
				var settings_string = variable_string.split( '.' );

				// Get the settings from the variable if it is more than one level deep loop to the end
				settings_var = window[ settings_string[ 0 ] ];

				if ( typeof settings_var === 'undefined' ) {
					settings_var = {};
				} else if ( settings_string.length > 1 ) {
					for ( var i = 1; i < settings_string.length; i++ ) {
						var temp = settings_var[ settings_string[ i ] ];
						if ( typeof temp === 'undefined' ) {
							settings_var = {};
							break;
						} else {
							settings_var = temp;
						}
					}
				} else {
					// Do nothing
				}
			}

			return settings_var;
		}
	};
});
